import { useEffect, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

import { Button, Box, FormControl, Grid, IconButton, InputAdornment, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography, Switch, Dialog, Select, MenuItem, RadioGroup, FormControlLabel, Radio, Autocomplete } from "@mui/material";

import CorporateFareIcon from '@mui/icons-material/CorporateFare';

import { Pagination } from "../../Pagination";
import ServiceLineDialog from "../ChangeSubOrgDialog";
// import CreateServiceLineDialog from "../CreateServiceLineDialog";
import './ServiceLines.css';
import AddIcon from '@mui/icons-material/Add';
import { checkLoggedInUserAuthorizedToViewPage, getDataFromLocalStorageParsed, getDecodeURI, getEncodedURI } from '../../../utils/util';

import { bulkUpdateServiceLineOrganization, getServiceLines, subscribeToServiceLines, optInForServiceLine, pauseResumeServiceLine, getAvailableProductsForAccount, clearComponentData, getSubscriptionForAccount, updateMultipleServiceLineOrganization, cancelDPOTransaction } from "../slice";
import SortArrows, { SortOrder } from "../../SortArrows";
import { ServiceLine } from "../types";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from '@mui/icons-material/Close';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import Download from '../../../asset/image/DownloadUsage.svg';
import { CsvParameters, downloadAsCSV } from "../../../actions/Users/authenticateCsvDownload";
import DownloadCSV, { clearCsvDownload } from "../../DownloadCSV";
import moment from "moment-timezone";
import { SERVICE_FUNCTION_TO_FEATURE } from "../../../config";
import SettingsIcon from '@mui/icons-material/Settings';
import EditActionsPopup from "./EditActionsPopup";
import CreateServiceLineDialog from "../CreateServiceLineDialog";
import _ from "lodash";
import SubscribeAllServiceLines from "./SubscribeAllServiceLines";
import AdminSLFilters from "./AdminSLFilters";
import TuneIcon from '@mui/icons-material/Tune';
import GoToQuota from "../../../asset/image/GoToQuotaPage.svg"
import { UPDATE_NEW_SUMMARY_SERVICE_LINE } from "../../../actions/types";


const convertToCsv = (data: any[][]) => {
    if (!Array.isArray(data) || data.length === 0) {
        return [['Organization', 'Sub Organization', 'Deployment', 'Service Line Number', 'Service Line Name', 'Service Plan', 'Status', 'User Terminals', 'Activation Date']];
    }
    const [_columns, ...rows] = data;
    const csvRows: any[] = [];
    rows.forEach(row => {
        if (!Array.isArray(row)) return;
        const activationDate = row[14] ? moment(row[14]) : null;
        csvRows.push([
            row[1] ?? '',
            row[10] ?? '',
            row[24] ?? '',
            row[25] ?? '',
            row[23] ?? '',
            row[27] ?? '',
            row[26] ? 'Active' : 'Inactive',
            String(row[35] ?? '').replaceAll(",", "; "),
            activationDate && activationDate.isValid() ? activationDate.format('YYYY-MM-DD') : '',
        ])
    })
    return [['Organization', 'Sub Organization', 'Deployment', 'Service Line Number', 'Service Line Name', 'Service Plan', 'Status', 'User Terminals', 'Activation Date'], ...csvRows]
}

interface ServiceLinesProps {
    authReducer: any;
    errorReducer: any;
    history: any;
    location: any;
    dpIds: string[];
    serviceLines: any[];
    totalServiceLines: number;
    getServiceLines: (parameters: any) => void;
    downloadAsCSV: (parameters: any) => void;
    subscribeToServiceLines: (parameters: any) => void;
    optInForServiceLine: (parameters: any) => void;
    pauseResumeServiceLine: (parameters: any) => void;
    clearComponentData: () => void;
    getAvailableProductsForAccount: (parameters: any) => void;
    bulkUpdateServiceLineOrganization: (parameters: any) => Promise<any>;
    updateMultipleServiceLineOrganization: (parameters: any) => Promise<any>;
    cancelDPOTransaction: (parameters: any) => Promise<any>;
    allServiceLines: any;
    availableProductsForAccount: any[];
    newSummaryServiceLine: any;
    getSubscriptionForAccount: any;
    subscriptionsForAccount: any;
    selectedServiceAccount:any;
    cancelTransaction: any;
}

interface OptInProps {
    serviceLineNumber: String,
    accountNumber: String,
    accountDpId: String,
    action: String,
    serviceLineName: String
}

interface PauseProps {
    serviceLineNumber: String,
    accountNumber: String,
    accountDpId: String,
    action: String,
    endNow: Boolean,
    serviceLineName: String
}

const STARLINK_ADMIN_SF = "starlink-admin";
const STARLINK_FULL_SF = "starlink-full";
const starlinkAdminService = SERVICE_FUNCTION_TO_FEATURE[STARLINK_ADMIN_SF]["service"];
const starlinkAdminFunction = SERVICE_FUNCTION_TO_FEATURE[STARLINK_ADMIN_SF]["function"];
const starlinkFullService = SERVICE_FUNCTION_TO_FEATURE[STARLINK_FULL_SF]["service"];
const starlinkFullFunction = SERVICE_FUNCTION_TO_FEATURE[STARLINK_FULL_SF]["function"];

export type ServiceLineSortBy = 'serviceLineName' | 'servicePlan' | 'userTerminals' | 'accountDpName' | 'dpName';

function ServiceLines(props: ServiceLinesProps) {

    const { authReducer, errorReducer, history, location, cancelTransaction, cancelDPOTransaction, dpIds, serviceLines, allServiceLines, selectedServiceAccount, subscriptionsForAccount, availableProductsForAccount, totalServiceLines, getServiceLines, bulkUpdateServiceLineOrganization, updateMultipleServiceLineOrganization, clearComponentData, downloadAsCSV, subscribeToServiceLines, getSubscriptionForAccount, optInForServiceLine, pauseResumeServiceLine, getAvailableProductsForAccount, newSummaryServiceLine } = props;

    const queryParams = new Map<string, string>(Object.entries(getDecodeURI(location.search)));
    const loggedInUser = getDataFromLocalStorageParsed("loggedInUser");
    const params = getDecodeURI(location.search)
    const firstRun = useRef(true);
    const [searchText, setSearchText] = useState<string>(queryParams.get('search') || '');
    const [optInDialog, setOptInDialog] = useState<boolean>(false);
    const [pauseDialog, setPauseDialog] = useState<boolean>(false);
    const [product, setProduct] = useState('');
    const [openSubscribeAll, setOpenSubscribeAll] = useState(false)
    const [switchServiceLineToggle, setSwitchServiceLineToggle] = useState(false)
    const [optInData, setOptInData] = useState<OptInProps>({
        serviceLineNumber: '',
        accountNumber: '',
        accountDpId: '',
        action: '',
        serviceLineName: ''
    });
    const [pauseData, setPauseData] = useState<PauseProps>({
        serviceLineNumber: '',
        accountNumber: '',
        accountDpId: '',
        action: '',
        endNow: false,
        serviceLineName: ''
    });

    const [tableParams, setTableParams] = useState<{
        page: number;
        size: number;
        sortBy: ServiceLineSortBy;
        sortOrder: SortOrder;
        search: string;
        serviceLineStatus: String[];
    }>({
        page: queryParams.has('page') ? parseInt(queryParams.get('page') as string) : 1,
        size: queryParams.has('size') ? parseInt(queryParams.get('size') as string) : 10,
        sortBy: queryParams.has('sortBy') ? queryParams.get('sortBy') as ServiceLineSortBy : 'serviceLineName',
        sortOrder: queryParams.has('sortOrder') ? queryParams.get('sortOrder') as SortOrder : 'asc',
        search: queryParams.has('search') ? queryParams.get('search') as string : '',
        serviceLineStatus: queryParams.has('serviceLineStatus') ? queryParams.get('serviceLineStatus')?.split(',') as string[] : ['true', 'false']
    });
    const [openSubscriptionDialog, setOpenSubscriptionDialog] = useState(false)
    const [subData, setSubData] = useState<any>(null)
    const [endNow, setEndNow] = useState(false)
    const [rejectReason, setRejectReason] = useState('')
    const [availableProducts, setAvailableProducts] = useState<{
        plan: string;
        product_reference_id: string;
    }[]>([])

    const [openServiceLineDialog, setOpenServiceLineDialog] = useState<boolean>(false);
    const [openCreateServiceLineDialog, setOpenCreateServiceLineDialog] = useState<boolean>(false);
    const [serviceLineToUpdate, setServiceLineToUpdate] = useState<any>(null);
    const searchTimeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>();
    const dispatch = useDispatch();
    const [editActionsPopup, setEditActionsPopup] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState({
        isOpen: false,
        title: "",
        subTitle: "",
        onConfirm: {},
    });
    const [selectedServiceLine, setSelectedServiceLine] = useState<any>({});
    const [mobilePriority, setMobilePriority] = useState(false);
    const [accountsData, setAccountsData] = useState<any>([]);
    const [newTerminalId, setNewTerminalId] = useState<any>(null);
    const [currentServiceLine, setCurrentServiceLine] = useState<any>(null);
    const userTerminalsData:any = []

    const [filters, setFilters] = useState({
        status: "all",
        subscriptionstatus: "all",
        kit: "hasKit"
    });
    
    const [filterPopup, setFilterPopup] = useState(false);
    const [anchorElRef, setAnchorElRef] = useState<HTMLElement>();
    const [filterPayload, setFilterPayload] = useState({
        kitFilter: "where kitCount > 0",
        subFilter: "",
        activeFilter: ""
    })

    const filterPopClick = (e: React.MouseEvent<HTMLElement>) => {
        setAnchorElRef(e.currentTarget);
        setFilterPopup(true);
    };

     const [isSLUpdated, setIsSLUpdated] = useState(false);

    const refreshServiceLineTable = (samePage: boolean = false) => {
        let _page = 1;
        if (samePage) {
            _page = tableParams.page;
        }
        setTableParams({
            ...tableParams,
            page: _page
        });
    }


    const handleOpenServiceLineDialog = () => {
        setOpenServiceLineDialog(true);
    }

    const handleAddServiceLineDialog = () =>{
        setOpenCreateServiceLineDialog(true)
        getSubscriptionForAccount({dpIds: authReducer?.selectedOu ? authReducer?.selectedOu?.id : null})
    }

    const handleCloseServiceLineDialog = () => {
        setOpenServiceLineDialog(false);
        setOpenCreateServiceLineDialog(false);
        setServiceLineToUpdate(null);
        setTimeout(()=>{
            handleChangeServiceLine()
        },20000)
    }

    const handleChangeSubOrg = async (dpId: string, serviceLineNumbers: string[]) => {
        await bulkUpdateServiceLineOrganization({
            serviceLineNumbers: serviceLineNumbers,
            dpId: dpId,
        });
        refreshServiceLineTable(true);
        setOpenServiceLineDialog(false);
        setServiceLineToUpdate(null);
    }

      const handleChangeMultipleSubOrg = async (dpId, serviceLineNumbers) => {
        await updateMultipleServiceLineOrganization({
            serviceLines: serviceLineNumbers,
            newDpId: dpId,
        });
        refreshServiceLineTable(true);
        setOpenServiceLineDialog(false);
        setServiceLineToUpdate(null);
    }

    const handleOnSearchClick = () => {
        handleSearch(searchText);
    }

    const handleOnSearchClear = () => {
        setSearchText('');
        handleSearch('');
    }

   useEffect(() => {
    if (!isSLUpdated) {
        setIsSLUpdated(true);
        return;
    }

    handleChangeServiceLine();

    if (filterPayload) {
        setFilterPopup(false);
    }
}, [editActionsPopup, filterPayload]);

    const handleChangeServiceLine = () =>{
        getServiceLines({
            accounts: selectedServiceAccount,
            dpIds,
            searchText: tableParams.search,
            sortBy: tableParams.sortBy,
            sortOrder: tableParams.sortOrder,
            page: tableParams.page,
            limit: tableParams.size,
            kitFilter: filterPayload?.kitFilter,
            subFilter: filterPayload?.subFilter,
            activeFilter: filterPayload?.activeFilter,
            // serviceLineStatus: tableParams.serviceLineStatus,
            serviceLines: Array.isArray(newSummaryServiceLine) ? newSummaryServiceLine?.filter(sl => sl !== '') : [],
        });
    }

  

    const handleOnSearchChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        setSearchText(e.target.value);
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
        searchTimeoutRef.current = setTimeout(() => {
            searchTimeoutRef.current = undefined;
            handleSearch(e.target.value);
        }, 1000)
    }

    const handleSearch = (value: string) => {
        setTableParams({
            ...tableParams,
            search: value,
            page: 1
        });
    }

    const handleChangePage = (event: any, newPage: number) => {
        setTableParams({ ...tableParams, page: newPage });
    };

    const handleChangeSize = (event: any) => {
        setTableParams({ ...tableParams, size: event.target.value, page: 1 });
    };

    const handleChangeSorting = (sortBy: ServiceLineSortBy, sortOrder: SortOrder) => {
        setTableParams({
            ...tableParams,
            sortBy: sortBy,
            sortOrder: sortOrder,
            page: 1
        });
    }

    const updateQueryParams = () => {
        queryParams.set('page', tableParams.page.toString())
        queryParams.set('size', tableParams.size.toString())
        queryParams.set('sortBy', tableParams.sortBy)
        queryParams.set('sortOrder', tableParams.sortOrder)
        queryParams.set('search', tableParams.search)
        queryParams.set('serviceLineStatus', tableParams.serviceLineStatus.join(','))
        history.replace({ pathname: location.pathname, search: `?${getEncodedURI(Object.fromEntries(queryParams.entries()))}` });
    }

    useEffect(() => {
        updateQueryParams();
        getSubscriptionForAccount({
            dpIds: authReducer?.selectedOu ? authReducer?.selectedOu?.id : null,
        });
        if (firstRun.current) {
            firstRun.current = false;
            return; 
        }

        clearComponentData();
        handleChangeServiceLine();
    }, [tableParams]);

    const prevSummaryRef = useRef<any>(null);

    useEffect(() => {

          if (!isSLUpdated) {
            setIsSLUpdated(true);
            return;
        }

        const prev = prevSummaryRef.current;
        const curr = newSummaryServiceLine;
    
        const isSame =
            prev &&
            Object.keys(curr).length === Object.keys(prev).length &&
            Object.keys(curr).every(key => curr[key] === prev[key]);
    
        if (!isSame) {
            handleChangeServiceLine();
            prevSummaryRef.current = curr;
        }
    }, [newSummaryServiceLine]);

    useEffect(() => {
        if (editActionsPopup && selectedServiceLine?.serviceLineNumber) {
            const updatedLine = serviceLines?.find(sl => sl.serviceLineNumber === selectedServiceLine.serviceLineNumber);
            if (updatedLine && !_.isEqual(updatedLine, selectedServiceLine)) {
                setSelectedServiceLine(updatedLine);
            }
        }
    }, [serviceLines, editActionsPopup]);


    const handleEdit = (serviceLine: any) => {
        setServiceLineToUpdate(serviceLine);
    }

    useEffect(() => {
        if (authReducer.csvDataDownloded && authReducer.csvDataDownloded.length > 0) {
            if (authReducer.csvDownloadId === 'service-lines-csv') {
                const [_columns, status] = authReducer.csvDataDownloded;
                if (status[0] === null) {
                    return;
                }
                if (status && status.length > 0) {
                    const rows = status[0];
                    if (rows.length) {
                        DownloadCSV(convertToCsv([Object.keys(rows[0]), ...rows.map(row => Object.values(row))]), {
                            formatters: {
                                0: 'ESC-COMMA', 
                                1: 'ESC-COMMA',
                                2: 'ESC-COMMA',
                                4: 'ESC-COMMA',
                                3: 'ESC-COMMA',
                                6: 'ESC-COMMA'
                            }
                        });
                    }
                }
                return () => {
                    dispatch(clearCsvDownload())
                }
            }
        }
    }, [authReducer.csvDataDownloded])

    const handleDownloadReport = () => {
        const params: CsvParameters = {
            type: 'QUERY_PG',
            id: 'service-lines-csv',
            payload: {
                dpIds: dpIds.map(dpId => `'${dpId}'`).join(','),
                searchText: tableParams.search,
                sortBy: tableParams.sortBy,
                sortOrder: tableParams.sortOrder,
                limit: totalServiceLines,
                offset: 0,
                kitFilter: filterPayload?.kitFilter,
                subFilter: filterPayload?.subFilter,
                activeFilter: filterPayload?.activeFilter,
                // serviceLineStatus: tableParams.serviceLineStatus.map(status => `'${status}'`).join(','),
                serviceLines: Array.isArray(newSummaryServiceLine) && newSummaryServiceLine?.filter(sl => sl != '').map(sl => `'${sl}'`).join(',')
            },
            queryName: 'GET_SERVICE_LINES_ADMIN_WITH_FILTERS',
        }
        downloadAsCSV(params);
    }

    const handlePauseResume = async () => {
        const requestData = {
            dpId: pauseData.accountDpId,
            serviceLineNumber: pauseData.serviceLineNumber,
            accountNumber: pauseData.accountNumber,
            action: pauseData.action,
            productReferenceId: product,
            endNow: endNow,
            rejectReason: rejectReason
        }
        await pauseResumeServiceLine(requestData)

        handleChangeServiceLine()
    }


    const handleChangeOptIn = async (sl, accountDpId, accountNumber, action) => {
        const requestData = {
            dpId: accountDpId,
            serviceLineNumber: sl,
            accountNumber: accountNumber,
            action: action
        }
        await optInForServiceLine(requestData)

        handleChangeServiceLine()
    }

    const handleChangeProduct = (event) => {
        setProduct(event.target.value)
    }

    const handleChangeEndNow = (event) => {
        setEndNow(event.target.value === "Yes" ? true : false)
    }

    const handleChangeSwitch = async (action, sl, dpId) => {
        const date = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");

        const requestData: { serviceLineNumber: any; dpId: string; user: any; action: string; startDate?: string | undefined; endDate?: string | undefined; } =
        {
            serviceLineNumber: [sl],
            dpId: dpId,
            user: loggedInUser?.data?.user?.userName,
            action: action
        };

        if (action === 'subscribe') {
            requestData.startDate = date;
        } else {
            requestData.endDate = date;
        }
        await subscribeToServiceLines(requestData);

        handleChangeServiceLine()

    }

    const handleCloseOptInDialog = () => {
        setOptInDialog(false)
        setPauseDialog(false)
        setOptInData({
            serviceLineNumber: '',
            accountNumber: '',
            accountDpId: '',
            action: '',
            serviceLineName: ''
        })
        setPauseData({
            serviceLineNumber: '',
            accountNumber: '',
            accountDpId: '',
            action: '', serviceLineName: '',
            endNow: false
        })
    }

    const handleOptIn = () => {
        if (optInData?.serviceLineNumber != '' && optInData?.accountDpId != '' && optInData?.accountNumber != '') {
            handleChangeOptIn(optInData?.serviceLineNumber, optInData?.accountDpId, optInData?.accountNumber, optInData.action)
        }
    }


    const handleChangeServiceLineStatus = (event: React.ChangeEvent<HTMLInputElement>) => {
        let _serviceLineStatus = ['true', 'false'];
        if (event.target.value === 'true') {
            _serviceLineStatus = ['true'];
        } else if (event.target.value === 'false') {
            _serviceLineStatus = ['false'];
        }

        setTableParams({
            ...tableParams,
            serviceLineStatus: _serviceLineStatus,
            page: 1
        });
    };

    useEffect(() => {
        if (availableProductsForAccount && availableProductsForAccount.length > 0) {
            let productSubscriptions: any[] = availableProductsForAccount.map(item => {
                return {
                    plan: item[0],
                    product_reference_id: item[1]
                };
            });
            setAvailableProducts(productSubscriptions)
        }

    }, [availableProductsForAccount])

    const handleCloseEditPopUp = () => {
        setEditActionsPopup(false);
    }

    const handleQuotaClick = (row: any) => {
    dispatch({ type: UPDATE_NEW_SUMMARY_SERVICE_LINE, payload: ["All"]})
    let params: any = getDecodeURI(location?.search);
    params.serviceLineAccess = row?.serviceLineNumber;
    delete params.sortBy;
    delete params.page;

    const newURL = `/starlink/quota?${getEncodedURI(params)}`;
    history.push(newURL);
};

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)

        const transactionToken = params.get('TransactionToken')
        const ccdApproval = params.get('CCDapproval')

        if (!transactionToken) return

        const isSuccess = Boolean(ccdApproval)

        if (isSuccess) {
            window.opener?.postMessage(
                { type: 'PAYMENT_COMPLETED', transactionToken },
                window.location.origin
            )

            window.close()
            return
        }

        cancelDPOTransaction({
            dpId: authReducer?.selectedOu?.id,
            transactionToken
        })
    }, [])

    useEffect(() => {
        if (!cancelTransaction || _.isEmpty(cancelTransaction)) return

        window.opener?.postMessage(
            { type: 'PAYMENT_CANCELLED' },
            window.location.origin
        )

         setTimeout(() => {
            window.close()
        }, 1500)

    }, [cancelTransaction])

    return (
        <Paper elevation={1} classes={{ root: 'starlink--base--mtb_07x starlink--base--padding_1x add-srcoll-starlink-subtab-pages' }}>
            {/* FILTERS */}
            <Grid classes={{ root: 'starlink--base--mtb_07x starlink--base--flex--align--center starlink--base--flex--justify--space_between' }}>
                <Grid>
                   
                    <Button
                        variant="outlined"
                        startIcon={<TuneIcon id="filterIcon" />}
                        onClick={filterPopClick}
                        id="filterButton"
                    >
                        Filter
                    </Button>
                </Grid>
                {filterPopup ?
                    <AdminSLFilters filterPopup={filterPopup} setFilterPopup={setFilterPopup} anchorElRef={anchorElRef} setTableParams={setTableParams} tableParams={tableParams} setFilterPayload={setFilterPayload}  setFilters={setFilters}  filters={filters} /> 
                    : null}
                <Grid classes={{ root: 'starlink--base--flex starlink--base--flex--align--center' }}>
                   
                    <Box>
                        <TextField
                            id="search"
                            variant="outlined"
                            placeholder="Type something"
                            autoComplete="off"
                            classes={{ root: "input-box-serviceline" }}
                            size="small"
                            value={searchText}
                            onChange={handleOnSearchChange}
                            onKeyDown={(e) => { if (e.key === 'Enter') { handleOnSearchClick() } }}
                            InputLabelProps={{ className: "serachLabel" }}
                            InputProps={{
                                className: "serachBar",
                                startAdornment: (
                                    <InputAdornment position="start">
                                        {!searchText && <SearchIcon
                                            className="cursorPointer input-search-icons" onClick={handleOnSearchClick}
                                        />}
                                        {searchText && <CloseIcon
                                            className="cursorPointer input-search-icons"
                                            onClick={handleOnSearchClear}
                                        />}
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>
                    {openServiceLineDialog && <ServiceLineDialog open={serviceLineToUpdate !== null || openServiceLineDialog} serviceLine={serviceLineToUpdate} onClose={handleCloseServiceLineDialog} onSaveMultiple={handleChangeMultipleSubOrg} />}
                    <Button size="small" variant="contained" disabled={!checkLoggedInUserAuthorizedToViewPage(starlinkAdminService, starlinkAdminFunction)} className='starlink--button_contained--primary' onClick={()=>{setOpenSubscribeAll(true)}} >Subscription</Button>
                    <Button size="small" variant="contained" disabled={!checkLoggedInUserAuthorizedToViewPage(starlinkAdminService, starlinkAdminFunction)} className='starlink--button_contained--primary' onClick={()=>{handleAddServiceLineDialog()}} startIcon={<AddIcon />}>Add Service Line</Button>
                    <Button size="small" variant="contained" disabled={!checkLoggedInUserAuthorizedToViewPage(starlinkAdminService, starlinkAdminFunction)} className='starlink--button_contained--primary' onClick={handleOpenServiceLineDialog} startIcon={<CorporateFareIcon />}>Assign</Button>

                    {/* <ServiceLineDialog open={serviceLineToUpdate !== null || openServiceLineDialog} serviceLine={serviceLineToUpdate} onClose={handleCloseServiceLineDialog} onSave={handleChangeSubOrg} /> */}
                    <CreateServiceLineDialog open={openCreateServiceLineDialog} serviceLine={serviceLineToUpdate} data={subscriptionsForAccount} onClose={handleCloseServiceLineDialog} onSave={handleChangeSubOrg} />
                    {totalServiceLines > 0 && <div className="download-summary-btn" onClick={handleDownloadReport}><img className="downloadImg" src={Download} alt="" /><Button>Download</Button></div>}
                </Grid>
            </Grid>

            {/* TABLE PAGINATION */}
            <Pagination count={totalServiceLines} onPageChange={handleChangePage} page={tableParams.page} rowsPerPage={tableParams.size} onRowsPerPageChange={handleChangeSize} />

            {/* SERVICE ACCOUNT TABLE */}
            <TableContainer component={Paper} className="starlink--table_container">
                <Table sx={{ minWidth: 650 }} size="small" aria-label="starlink--service_accounts">
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <SortArrows sortBy={tableParams.sortBy} sortOrder={tableParams.sortOrder} field="accountDpName" onChange={handleChangeSorting}>
                                    <span className="font-wt-900">ORGANIZATION</span>
                                </SortArrows>
                            </TableCell>
                            <TableCell>
                                <SortArrows sortBy={tableParams.sortBy} sortOrder={tableParams.sortOrder} field="dpName" onChange={handleChangeSorting}>
                                    <span className="font-wt-900">SUB ORGANIZATION</span>
                                </SortArrows>
                            </TableCell>
                            <TableCell className="starlink-sl-number">
                                <SortArrows sortBy={tableParams.sortBy} sortOrder={tableParams.sortOrder} field="serviceLineName" onChange={handleChangeSorting}>
                                <div className="starlink-service-line-toggle">
                                    <span className="font-wt-900">SERVICE LINE</span>
                                    <div
                                    onClick={(e) => e.stopPropagation()} 
                                    onMouseDown={(e) => e.stopPropagation()} >
                                        <Tooltip title="SL Name / SL Number">
                                    <Switch size="small"
                                        checked={switchServiceLineToggle}
                                        onChange={(e) => {  e.stopPropagation();  setSwitchServiceLineToggle(!switchServiceLineToggle) }}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                    />
                                    </Tooltip>
                                    </div>
                                    </div>
                                </SortArrows>
                            </TableCell>
                            <TableCell>
                                <SortArrows sortBy={tableParams.sortBy} sortOrder={tableParams.sortOrder} field="servicePlan" onChange={handleChangeSorting}>
                                    <span className="font-wt-900">SERVICE PLAN</span>
                                </SortArrows>
                            </TableCell>

                            <TableCell>
                                <span className="font-wt-900">STATUS</span>
                            </TableCell>

                            <TableCell>
                                <span className="font-wt-900">ACTIVATION DATE</span>
                            </TableCell>

                            <TableCell>
                                <SortArrows sortBy={tableParams.sortBy} sortOrder={tableParams.sortOrder} field="userTerminals" onChange={handleChangeSorting}>
                                    <span className="font-wt-900">USER TERMINALS</span>
                                </SortArrows>
                            </TableCell>
                            <TableCell className="starlink-admin-serviceLines-action-colm">
                                <span className="font-wt-900">OPERATIONS</span>
                            </TableCell>

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            serviceLines?.length > 0 ? serviceLines.map((serviceLine: ServiceLine) => {
                                return <TableRow
                                    key={serviceLine?.serviceLineNumber}
                                >
                                    <TableCell>
                                        {serviceLine?.accountDpName}
                                    </TableCell>
                                    <TableCell>
                                        {serviceLine?.dpName}
                                    </TableCell>
                                    <TableCell>
                                        {switchServiceLineToggle ? serviceLine?.serviceLineNumber : serviceLine?.serviceLineName}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Tooltip
                                            classes={{ tooltip: 'starlink--tooltip' }}
                                            componentsProps={{ tooltip: { style: { maxWidth: 'none' } } }}
                                            title={
                                                serviceLine?.data_block_product_details && (
                                                    <Table size="small" padding="none">
                                                        <TableHead>
                                                            <TableRow className="str-plan-tooltipRow">
                                                                <TableCell className="str-plan-tooltipCell">Type</TableCell>
                                                                <TableCell className="str-plan-tooltipCell">Count</TableCell>
                                                                <TableCell className="str-plan-tooltipCell">Per block (GB)</TableCell>
                                                                <TableCell className="str-plan-tooltipCell">Total (GB)</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {(() => {
                                                                const GROUPS = {
                                                                    dataBlockProduct: { label: 'Plan data block', count: 0, dataAmounts: [] as number[], total: 0 },
                                                                    topUpProduct: { label: 'Top up data block', count: 0, dataAmounts: [] as number[], total: 0 },
                                                                };
                                                                serviceLine.data_block_product_details
                                                                    .filter(item => item.type === 'CurrentBillingCycle')
                                                                    .forEach(item => {
                                                                        if (GROUPS[item.product_type]) {
                                                                            GROUPS[item.product_type].count += item.count;
                                                                            GROUPS[item.product_type].dataAmounts.push(item.data_amount);
                                                                            GROUPS[item.product_type].total += item.count * item.data_amount;
                                                                        }
                                                                    });
                                                                const grandTotal = Object.values(GROUPS).reduce((sum, g) => sum + g.total, 0);
                                                                const rows = Object.entries(GROUPS).filter(([, g]) => g.count > 0);
                                                                const uniqueAmount = (amounts: number[]) => {
                                                                    const u = Array.from(new Set(amounts));
                                                                    return u.length === 1 ? u[0] : '-';
                                                                };
                                                                return (
                                                                    <>
                                                                        {rows.map(([key, g]) => (
                                                                            <TableRow className="str-plan-tooltipRow" key={key}>
                                                                                <TableCell className="str-plan-tooltipPadding">{g.label}</TableCell>
                                                                                <TableCell className="str-plan-tooltipPadding">{g.count}</TableCell>
                                                                                <TableCell className="str-plan-tooltipPadding">{uniqueAmount(g.dataAmounts)}</TableCell>
                                                                                <TableCell className="str-plan-tooltipPadding">{g.total}</TableCell>
                                                                            </TableRow>
                                                                        ))}
                                                                        <TableRow className="str-plan-tooltipTotalRow">
                                                                            <TableCell>Total</TableCell>
                                                                            <TableCell />
                                                                            <TableCell />
                                                                            <TableCell>{grandTotal} GB</TableCell>
                                                                        </TableRow>
                                                                    </>
                                                                );
                                                            })()}
                                                        </TableBody>
                                                    </Table>
                                                )
                                            }
                                        >
                                            <Box display="flex" alignItems="center" justifyContent="flex-start" gap={0.5}>
                                                <span>{serviceLine?.servicePlan || '-'}</span>
                                                {serviceLine?.schedule_action && serviceLine?.schedule_plan_date && (
                                                    <Tooltip title={`Scheduled for ${serviceLine?.schedule_action} on ${moment(serviceLine?.schedule_plan_date).format("DD/MMM/YYYY")}` || '-'}>
                                                        <span>
                                                            <PriorityHighIcon style={{ color: 'red', fontSize: 18 }} />
                                                        </span>
                                                    </Tooltip>
                                                )}
                                            </Box>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell>
                                        {serviceLine.serviceLineStatus ? "Active" : 'Inactive'}
                                    </TableCell>
                                    <TableCell>
                                        {serviceLine?.lastSubscribedDate && moment(serviceLine.lastSubscribedDate).isValid() ? moment(serviceLine.lastSubscribedDate).format("YYYY-MM-DD") : '-'}
                                    </TableCell>
                                    <TableCell>
                                    <Tooltip title={serviceLine?.userTerminals ? serviceLine?.userTerminals : '-'}>
                                      <div> {serviceLine.userTerminals ? serviceLine.userTerminals?.length > 28 ?  `${serviceLine.userTerminals.slice(0, 28)}...`  : serviceLine.userTerminals  : '-'} </div> 
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell>
                                        {/* edit */}
                                        <Grid container className="starlink-admin-service-lines-actions-td">
                                            <Tooltip title={serviceLine.servicelineSubscription ? "Starlink Cloud : Subscribed" : "Starlink Cloud : UnSubscribed"}>
                                                <div>
                                                    <Switch
                                                        checked={serviceLine.servicelineSubscription}
                                                        disabled={!checkLoggedInUserAuthorizedToViewPage(starlinkAdminService, starlinkAdminFunction)}
                                                        onChange={(e) => { setSubData(serviceLine); setOpenSubscriptionDialog(true)}}
                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                    />
                                                </div>
                                            </Tooltip>
                                            <Tooltip title={!serviceLine.servicelineSubscription ? `Subscribe to service line to access actions` : "Actions"}>
                                                <div>
                                                    <IconButton
                                                        className="starlink-change-sub-org"
                                                        disabled={!serviceLine.servicelineSubscription}
                                                        size='small'>
                                                        <SettingsIcon  className={!serviceLine.servicelineSubscription ? `inventory-edit-icon-disabled starlink-admin-service-lines-actions` : `inventory-edit-icon starlink-admin-service-lines-actions` }
                                                            onClick={() => { setEditActionsPopup(true); setSelectedServiceLine(serviceLine) }} />
                                                    </IconButton>
                                                </div>
                                            </Tooltip>
                                            <Tooltip title={"Go to Quota Kontrol"}>
                                                <div>
                                                  <img onClick={() => handleQuotaClick(serviceLine)} className="icon-cursor" style={{ marginTop: "7px" }} src={GoToQuota} />
                                                </div>
                                            </Tooltip>
                                        </Grid>
                                    </TableCell>
                                </TableRow>
                            }) : <TableRow>
                                <TableCell colSpan={8} align='center'>
                                    No data available
                                </TableCell>
                            </TableRow>
                        }
                    </TableBody>
                </Table>
            </TableContainer>

            <Dialog
                open={openSubscriptionDialog}
                onClose={() => { setOpenSubscriptionDialog(false); setSubData(null); }}
                maxWidth="md" 
                fullWidth 
                PaperProps={{
                    style: {
                        overflow: 'hidden' 
                    }
                }}
            >
                <Grid container spacing={2} style={{ padding: '1em' }}>
                    <Grid item xs={12}>
                        <Typography variant="h5" component="div" align="center" style={{ fontWeight: 'bold', color: "#424141" }}>
                            {subData?.servicelineSubscription ? "UnSubscribe" : "Subscribe"}  Service Line {subData?.serviceLineName}.
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="h6" component="div" align="center">
                            Do you want to {subData?.servicelineSubscription ? "unsubscribe" : "subscribe"}?
                        </Typography>
                    </Grid>

                    <Grid item xs={12} className="starlink--base--flex starlink--base--mtb_07x starlink--base--flex--justify--end">
                        <Button
                            variant="outlined"
                            className='starlink--button--cancel'
                            onClick={() => { setOpenSubscriptionDialog(false); setSubData(null); }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            className='starlink--button_contained--primary'
                            onClick={async(e) => { await handleChangeSwitch(subData?.servicelineSubscription ? "unsubscribe" : "subscribe", subData.serviceLineNumber, subData.dpId); setOpenSubscriptionDialog(false); setSubData(null); }}
                        >
                            {subData?.servicelineSubscription ? "UnSubscribe" : "Subscribe"}
                        </Button>
                    </Grid>
                </Grid>
            </Dialog>


            <Dialog open={optInDialog} onClose={handleCloseOptInDialog} aria-labelledby="service_account--dialog" maxWidth="md" fullWidth>
                <Grid classes={{ root: 'starlink--base--padding_1x' }}>
                    <Grid classes={{ root: 'starlink--base--mtb_07x' }}>
                        <Typography component="div" className="starlink--base--font_2x">
                            {optInData && optInData?.action != '' && optInData?.action == "optOut" ? "Disable" : "Enable"}  Mobile Priority for {optInData?.serviceLineName}.
                        </Typography>
                        <Typography component="div" className="starlink--base--font_1x">
                            {optInData && optInData?.action != '' && optInData?.action == "optOut" ?
                                "Data will continue to be charged for up to 15 minutes." :
                                "Charges will be incurred until Mobie Priority is disabled. Mobile Priority will begin within 15 minutes "

                            }
                        </Typography>
                    </Grid>

                    <Grid classes={{ root: 'starlink--base--flex starlink--base--mtb_07x starlink--base--flex--justify--end' }}>
                        <Button variant="outlined" className='starlink--button--cancel' onClick={handleCloseOptInDialog}>Cancel</Button>
                        <Button variant="contained" className='starlink--button_contained--primary' onClick={handleOptIn} >{optInData && optInData?.action != '' && optInData?.action == "optOut" ? "Disable" : "Enable"}</Button>
                    </Grid>
                </Grid>
            </Dialog>

            <Dialog open={pauseDialog} onClose={handleCloseOptInDialog} aria-labelledby="service_account--dialog" maxWidth="sm" fullWidth>
                <Grid classes={{ root: 'starlink--base--padding_1x' }}>
                    <Grid classes={{ root: 'starlink--base--mtb_07x' }}>
                        <Typography component="div" className="starlink--base--font_2x">
                            {pauseData && pauseData?.action != '' && pauseData?.action} Service Line - {pauseData?.serviceLineName}

                        </Typography>


                        {pauseData && pauseData?.action != '' && pauseData?.action === "Pause" &&
                            <>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography component="div" className="starlink--base--font_1x">
                                        End on
                                    </Typography>

                                    <FormControl sx={{ m: 2, minWidth: 400 }}>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={endNow === true ? "Yes" : "No"}
                                            label=""
                                            onChange={handleChangeEndNow}
                                        >
                                            <MenuItem value="Yes">Now</MenuItem>
                                            <MenuItem value="No">Billing Date</MenuItem>

                                        </Select>
                                    </FormControl>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography component="div" className="starlink--base--font_1x">
                                        Reason
                                    </Typography>

                                    <FormControl sx={{ m: 2, minWidth: 400 }}>
                                        <TextField sx={{ padding: 0 }}
                                            className="audit-filter-inputs"
                                            size="small"
                                            variant="outlined"
                                            placeholder=""
                                            value={rejectReason}
                                            onChange={(e) => { setRejectReason(e.target.value) }}

                                        />
                                    </FormControl>
                                </div>
                            </>
                        }


                        {pauseData && pauseData?.action != '' && pauseData?.action === "Resume" &&
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Typography component="div" className="starlink--base--font_1x">
                                    Select Products
                                </Typography>
                                <FormControl sx={{ m: 2, minWidth: 400 }}>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={product}
                                        label="Age"
                                        onChange={(e) => { handleChangeProduct(e) }}
                                    >
                                        {availableProducts.map((product) => {
                                            return <MenuItem value={product.product_reference_id}>{product.plan}</MenuItem>
                                        })}

                                    </Select>
                                </FormControl>
                            </div>
                        }

                    </Grid>

                    <Grid classes={{ root: 'starlink--base--flex starlink--base--mtb_07x starlink--base--flex--justify--end' }}>
                        <Button variant="outlined" className='starlink--button--cancel' onClick={handleCloseOptInDialog}>Cancel</Button>
                        <Button variant="contained" className='starlink--button_contained--primary' onClick={handlePauseResume} disabled={pauseData && pauseData?.action != '' && pauseData?.action === "Resume" && product == ''}>{pauseData && pauseData?.action != '' && pauseData?.action}</Button>
                    </Grid>
                </Grid>
            </Dialog>

            {openSubscribeAll && <SubscribeAllServiceLines open={openSubscribeAll} setOpen={setOpenSubscribeAll} />  }

            {editActionsPopup ? <EditActionsPopup
                open={editActionsPopup} setOpen={()=>{handleCloseEditPopUp()}}
                confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog}
                row={selectedServiceLine} setRow={setSelectedServiceLine} handleChangeServiceLine={handleChangeServiceLine}
                handleEdit={handleEdit} serviceLine={serviceLineToUpdate} availableCustomPlans={subscriptionsForAccount}
                onSave={handleChangeSubOrg} starlinkService={starlinkAdminService} starlinkFunction={starlinkAdminFunction}
                pauseData={pauseData} setPauseData={setPauseData} endNow={endNow} handleChangeEndNow={handleChangeEndNow} rejectReason={rejectReason} setRejectReason={setRejectReason}
                product={product} setProduct={setProduct} handleChangeProduct={handleChangeProduct} availableProducts={availableProducts} handlePauseResume={handlePauseResume}
                optInData={optInData} setOptInData={setOptInData} mobilePriority={mobilePriority} setMobilePriority={setMobilePriority} handleOptIn={handleOptIn} dpIds={dpIds}
            /> : null}
        </Paper>
    );
}

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
    dpIds: state.starlinkCloud.dpIds,
    serviceLines: state.starlinkAdmin.serviceLines,
    totalServiceLines: state.starlinkAdmin.totalServiceLines,
    allServiceLines: state.starlinkReports.allServiceLines,
    availableProductsForAccount: state.starlinkAdmin.availableProductsForAccount,
    newSummaryServiceLine: state?.authReducer?.newSummaryServiceLine,
    subscriptionsForAccount: state.starlinkAdmin.subscriptionsForAccount,
    selectedServiceAccount: state?.authReducer?.selectedServiceAccount,
    cancelTransaction: state?.starlinkAdmin?.cancelTransaction
});

export default withRouter(
    connect(mapStateToProps, {
        getServiceLines,
        bulkUpdateServiceLineOrganization,
        updateMultipleServiceLineOrganization,
        downloadAsCSV,
        subscribeToServiceLines,
        optInForServiceLine,
        pauseResumeServiceLine,
        getAvailableProductsForAccount,
        clearComponentData,
        getSubscriptionForAccount,
        cancelDPOTransaction
    })(ServiceLines)
);